/* eslint-disable class-methods-use-this */
import { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div className="container-fluid">
        <h1>
          The requested URL is not found
        </h1>
      </div>
    );
  }
}

export default NotFound;
